
import React from 'react';

const Schedule = () => {
  return (
    <div>
      <h2>Class Schedule</h2>
      <p>Here is the class schedule.</p>
      {/* Add schedule component here */}
    </div>
  );
};

export default Schedule;
